import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "py-4 space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 商品情報 ")
], -1)
const _hoisted_4 = { class: "px-4 space-y-4" }
const _hoisted_5 = { class: "flex space-x-2" }
const _hoisted_6 = { class: "shrink-0" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col justify-between" }
const _hoisted_9 = { class: "align-middle text-sm font-bold text-left line-clamp-2" }
const _hoisted_10 = { class: "text-xs text-left line-clamp-2" }
const _hoisted_11 = { class: "py-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle" }, "支払い金額", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_16 = {
  key: 1,
  class: "text-green-lightShow text-xs font-bold align-middle mr-2"
}
const _hoisted_17 = {
  key: 2,
  class: "text-green-lightShow text-lg font-bold mr-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle" }, "支払い金額", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_22 = {
  key: 1,
  class: "text-green-lightShow text-xs font-bold align-middle mr-2"
}
const _hoisted_23 = {
  key: 2,
  class: "text-green-lightShow text-lg font-bold mr-2"
}
const _hoisted_24 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle ml-4" }, "優待価格", -1)
const _hoisted_26 = { class: "text-green-lightShow text-sm align-middle mr-2" }
const _hoisted_27 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle ml-4" }, "追加料金", -1)
const _hoisted_29 = { class: "text-green-lightShow text-sm align-middle mr-2" }
const _hoisted_30 = {
  key: 0,
  class: "flex border-b pb-4 space-x-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "grow text-left table" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-cell align-middle space-y-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "認証が必要です"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, " この特別優待を利用するには提供店舗から承認を得て下さい。 ")
  ])
], -1)
const _hoisted_32 = { class: "shrink-0" }
const _hoisted_33 = {
  key: 0,
  class: "flex h-full"
}
const _hoisted_34 = { class: "flex m-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "認証済み", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", { class: "py-2 px-4 bg-green-show text-white rounded" }, " 認証する ", -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 支払い情報 ")
], -1)
const _hoisted_39 = {
  key: 0,
  class: "text-green-lightShow text-lg font-bold align-middle"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "px-4" }
const _hoisted_42 = { class: "space-y-4" }
const _hoisted_43 = { class: "flex space-x-4 text-left border-b pb-4 justify-between" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "支払い方法", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_46 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_47 = {
  key: 0,
  class: "flex space-x-4 text-left border-b pb-4 justify-between"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "カード情報", -1)
const _hoisted_49 = { class: "text-sm" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 発送情報 ", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "px-4"
}
const _hoisted_55 = { class: "space-y-4" }
const _hoisted_56 = { class: "flex space-x-4 text-left border-b pb-4 justify-between" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "お名前", -1)
const _hoisted_58 = { class: "text-sm" }
const _hoisted_59 = { class: "flex space-x-4 text-left border-b pb-4 justify-between" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "発送先", -1)
const _hoisted_61 = { class: "text-sm" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " お客さま情報 ", -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  key: 1,
  class: "px-4"
}
const _hoisted_68 = { class: "space-y-4" }
const _hoisted_69 = { class: "flex space-x-4 text-left border-b pb-4 justify-between" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "お名前", -1)
const _hoisted_71 = { class: "text-sm" }
const _hoisted_72 = { class: "flex space-x-4 text-left border-b pb-4 justify-between" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "住所", -1)
const _hoisted_74 = { class: "text-sm" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "space-y-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-left" }, "認証コードの入力")
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-left" }, " ご利用いただく店舗から伝えられた認証コードを入力してください ")
], -1)
const _hoisted_80 = {
  key: 0,
  class: "text-xs text-red-500 pb-4 text-left"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm" }, "認証する", -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 1,
  class: "h-full"
}
const _hoisted_84 = { class: "space-y-6 m-auto" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-center" }, "認証完了")
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "認証コードを確認しました"),
  /*#__PURE__*/_createElementVNode("p", null, "この画面をスタッフにお見せください")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm" }, "閉じる", -1)
const _hoisted_88 = [
  _hoisted_87
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_van_password_input = _resolveComponent("van-password-input")!
  const _component_van_number_keyboard = _resolveComponent("van-number-keyboard")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "flex justify-between",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goVoucherDetail()))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.voucherReserve.voucher?.images[0].imageUrl,
                alt: "",
                class: "h-20 w-20 object-cover"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.voucherReserve.voucher?.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.voucherReserve.createDate
                      ? `受付日時：${_ctx.ymd(_ctx.voucherReserve.createDate)}`
                      : ``), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (
              _ctx.voucherReserve.voucher?.voucherType == _ctx.VoucherTypes.Experience
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  (
                  !_ctx.voucherReserve.voucher?.discountedPrice &&
                  _ctx.voucherReserve.voucher?.discountType === _ctx.DiscountTypes.Rate
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.voucherReserve.voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.voucherReserve.voucher.discountType]), 1))
                    : (!_ctx.voucherReserve.voucher?.discountedPrice)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.voucherReserve.voucher?.summary), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, " ￥" + _toDisplayString(_ctx.voucherReserve.totalPrice.toLocaleString()), 1))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  (
                  !_ctx.voucherReserve.voucher?.discountedPrice &&
                  _ctx.voucherReserve.voucher?.discountType === _ctx.DiscountTypes.Rate
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.voucherReserve.voucher.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.voucherReserve.voucher.discountType]), 1))
                    : (!_ctx.voucherReserve.voucher?.discountedPrice)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.voucherReserve.voucher?.summary), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, " ￥" + _toDisplayString(_ctx.voucherReserve.totalPrice.toLocaleString()), 1))
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, "￥" + _toDisplayString(_ctx.voucherReserve.voucher?.discountedPrice.toLocaleString()), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", _hoisted_29, "￥" + _toDisplayString(_ctx.voucherReserve.additionalCost.toLocaleString()), 1)
                ])
              ]))
        ]),
        (_ctx.voucherReserve.voucher?.isNeedVerify)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                (_ctx.voucherReserve.voucherReserveReceipt?.isVerified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_CheckCircleIcon, { class: "h-6 w-6 text-green-lightShow" }),
                        _hoisted_35
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "flex items-center h-full",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openVerifyPopup && _ctx.openVerifyPopup(...args)))
                    }, _hoisted_37))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_38,
      (
          _ctx.voucherReserve.status == _ctx.ReserveStatuses.Done &&
          !_ctx.voucherReserve?.voucherReserveReceipt
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, " SHOW外部（銀行振込等）で決済されています "))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  (_ctx.voucherReserve.voucherReserveReceipt?.userPaymentMethod)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, " クレジットカード "))
                    : (_openBlock(), _createElementBlock("p", _hoisted_46, "現地決済"))
                ]),
                (_ctx.voucherReserve.voucherReserveReceipt?.userPaymentMethod)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("p", _hoisted_49, " ************ " + _toDisplayString(_ctx.voucherReserve.voucherReserveReceipt?.userPaymentMethod?.last4) + " (" + _toDisplayString(_ctx.voucherReserve.voucherReserveReceipt?.userPaymentMethod
                    ?.brand) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.voucherReserve.voucher?.voucherType == _ctx.VoucherTypes.Product)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (_ctx.voucherReserve.userAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                    : _createCommentVNode("", true),
                  (_ctx.voucherReserve.userAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.voucherReserve.userAddress?.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("p", _hoisted_61, [
                              _createTextVNode(_toDisplayString(_ctx.voucherReserve.userAddress?.zipCode), 1),
                              _hoisted_62,
                              _createTextVNode(" " + _toDisplayString(_ctx.voucherReserve.userAddress?.cityName) + _toDisplayString(_ctx.voucherReserve.userAddress?.streetName) + _toDisplayString(_ctx.voucherReserve.userAddress?.buildingName), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  (_ctx.voucherReserve.userAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_66))
                    : _createCommentVNode("", true),
                  (_ctx.voucherReserve.userAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.voucherReserve.userAddress?.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createElementVNode("p", _hoisted_74, [
                              _createTextVNode(_toDisplayString(_ctx.voucherReserve.userAddress?.zipCode), 1),
                              _hoisted_75,
                              _createTextVNode(" " + _toDisplayString(_ctx.voucherReserve.userAddress?.cityName) + _toDisplayString(_ctx.voucherReserve.userAddress?.streetName) + _toDisplayString(_ctx.voucherReserve.userAddress?.buildingName), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]))
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showVerifyPopup,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showVerifyPopup) = $event)),
      position: "bottom",
      style: {height: '80%'},
      closeable: true,
      round: true,
      class: "bg-gray-lightShow py-12 px-4",
      onClosed: _ctx.resetInputValue
    }, {
      default: _withCtx(() => [
        (!_ctx.isVerifySuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _hoisted_79,
                _createElementVNode("div", {
                  class: _normalizeClass(["py-2", 
              _ctx.isInvalidVerifyCodeError ? 's-verify-code-error' : 's-verify-code'
            ])
                }, [
                  (_ctx.isInvalidVerifyCodeError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_80, " 認証コードが誤っています。再度ご入力ください。 "))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_password_input, {
                    value: _ctx.inputValue,
                    mask: false,
                    focused: _ctx.showKeyboard,
                    gutter: 10,
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showKeyboard = true))
                  }, null, 8, ["value", "focused"])
                ], 2),
                _createElementVNode("div", {
                  class: "bg-green-show w-full rounded-md py-3",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.verifyReserve && _ctx.verifyReserve(...args)))
                }, _hoisted_82)
              ]),
              _createVNode(_component_van_number_keyboard, {
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValue) = $event)),
                show: _ctx.showKeyboard,
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showKeyboard = false))
              }, null, 8, ["modelValue", "show"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_CheckCircleIcon, { class: "w-1/2 h-auto m-auto animate-bounce" }),
                _hoisted_85,
                _hoisted_86,
                _createElementVNode("div", {
                  class: "bg-green-show w-full rounded-md py-3",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
                }, _hoisted_88)
              ])
            ]))
      ]),
      _: 1
    }, 8, ["show", "onClosed"])
  ]))
}